import React, { createContext, useContext, useMemo, useState } from 'react';

const LoginModalContext = createContext(null);

function sanitizeRedirectPath(path) {
  if (typeof path !== 'string') return '/';
  // Only allow relative paths to prevent open redirects.
  if (!path.startsWith('/')) return '/';
  return path;
}

export function LoginModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [redirectPath, setRedirectPath] = useState('/');

  const openLogin = (options = {}) => {
    const nextRedirect = sanitizeRedirectPath(
      options.redirectPath || `${window.location.pathname}${window.location.search || ''}`,
    );
    setRedirectPath(nextRedirect);
    setIsOpen(true);
  };

  const closeLogin = () => {
    setIsOpen(false);
  };

  const value = useMemo(
    () => ({
      isOpen,
      redirectPath,
      openLogin,
      closeLogin,
    }),
    [isOpen, redirectPath],
  );

  return <LoginModalContext.Provider value={value}>{children}</LoginModalContext.Provider>;
}

export function useLoginModal() {
  const ctx = useContext(LoginModalContext);
  if (!ctx) {
    throw new Error('useLoginModal must be used within a LoginModalProvider');
  }
  return ctx;
}

